/**
 * 메인 사이트 전용 UI 묶음 (레이아웃 main, jQuery/GSAP 전역 의존).
 * Lenis는 LenisController 단일 인스턴스만 사용 — 여기서는 중복 생성하지 않음.
 */
import { HomeAosLightbox } from "./HomeModule/HomeAosLightbox";
import { HomeViewport } from "./HomeModule/HomeViewport";
import { HomeScrambleLinks } from "./HomeModule/HomeScrambleLinks";
import { HomeDrawerGsap } from "./HomeModule/HomeDrawerGsap";
import { HomeScrollAnimations } from "./HomeModule/HomeScrollAnimations";
import { HomeTextEffects } from "./HomeModule/HomeTextEffects";
import { HomeVisualCursor } from "./HomeModule/HomeVisualCursor";
import { HomeFormPopup } from "./HomeModule/HomeFormPopup";
import { HomeTopButton } from "./HomeModule/HomeTopButton";

export class HomeModule {
    /**
     * Lenis + ScrollTrigger proxy 가 먼저 초기화된 뒤 호출할 것 (app.runGlobalInits 순서).
     */
    init(): void {
        HomeAosLightbox.init();

        const gsap = window.gsap;
        const ST = (window as unknown as { ScrollTrigger?: object })
            .ScrollTrigger;
        if (gsap && ST) {
            gsap.registerPlugin(ST);
        }

        HomeViewport.init();
        HomeScrambleLinks.init();
        HomeDrawerGsap.init();
        HomeScrollAnimations.init();
        HomeTextEffects.init();
        HomeVisualCursor.init();
        HomeFormPopup.init();
        HomeTopButton.init();
    }
}

export function initHomeModule(): void {
    new HomeModule().init();
}
